import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { PlanHeader } from '../owner/PlanFeature';
import TaskListView from '../owner/TaskListView';
import TaskCalendarView from '../owner/TaskCalendarView';
import OwnerChat from '../owner/OwnerChat';
import PlanNotes from '../common/PlanNotes';
import ResourceLibrary from '../owner/ResourceLibrary';

const OwnerPreviewModal = ({ isOpen, onClose, plan, tasks, client, onUpdate }) => {
  const [viewMode, setViewMode] = useState('list');
  const [activeTab, setActiveTab] = useState('plan');

  if (!isOpen || !plan || !client) return null;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/80 backdrop-blur-md z-[10000] flex flex-col pt-12"
      >
        {/* Modal Header / Toolbar */}
        <div className="bg-indigo-900 text-white px-6 py-4 flex justify-between items-center shadow-2xl border-b border-white/10">
          <div className="flex items-center gap-4">
            <div className="bg-yellow-400 text-indigo-900 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
              Preview Mode
            </div>
            <h2 className="font-bold text-sm hidden sm:block">
              Viewing as: <span className="text-indigo-200">{client.owner_name} & {client.dog_name}</span>
            </h2>
          </div>
          <button onClick={onClose} className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl transition-all font-bold text-sm">
            <SafeIcon name="X" /> Exit Preview
          </button>
        </div>

        {/* Owner Portal Content Simulation */}
        <div className="flex-1 overflow-y-auto bg-gray-50">
          <div className="max-w-4xl mx-auto pb-20">
            <PlanHeader plan={plan} client={client} />
            
            <div className="px-4 mt-6">
              <div className="flex gap-6 border-b mb-6 overflow-x-auto whitespace-nowrap scrollbar-hide">
                <button onClick={() => setActiveTab('plan')} className={`pb-3 font-bold border-b-2 transition-all ${activeTab === 'plan' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400'}`}>Training Plan</button>
                <button onClick={() => setActiveTab('library')} className={`pb-3 font-bold border-b-2 transition-all ${activeTab === 'library' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400'}`}>Support Library</button>
                <button onClick={() => setActiveTab('notes')} className={`pb-3 font-bold border-b-2 transition-all ${activeTab === 'notes' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400'}`}>Notes & Journal</button>
                <button onClick={() => setActiveTab('messages')} className={`pb-3 font-bold border-b-2 transition-all ${activeTab === 'messages' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400'}`}>Messages</button>
              </div>

              {activeTab === 'plan' && (
                <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                  <div className="flex justify-center mb-6">
                    <div className="bg-white p-1 rounded-xl border border-gray-200 inline-flex shadow-sm">
                      <button onClick={() => setViewMode('list')} className={`px-6 py-2 rounded-lg text-sm font-bold transition-all ${viewMode === 'list' ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-500 hover:text-gray-700'}`}>List View</button>
                      <button onClick={() => setViewMode('calendar')} className={`px-6 py-2 rounded-lg text-sm font-bold transition-all ${viewMode === 'calendar' ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-500 hover:text-gray-700'}`}>Calendar</button>
                    </div>
                  </div>
                  {viewMode === 'list' ? <TaskListView tasks={tasks} onUpdate={onUpdate} /> : <TaskCalendarView tasks={tasks} onUpdate={onUpdate} />}
                </div>
              )}

              {activeTab === 'library' && <div className="animate-in fade-in slide-in-from-bottom-4 duration-500"><ResourceLibrary trainerId={client.trainer_id} /></div>}
              {activeTab === 'notes' && <div className="animate-in fade-in slide-in-from-bottom-4 duration-500"><PlanNotes planId={plan.id} userRole="owner" /></div>}
              {activeTab === 'messages' && <div className="animate-in fade-in slide-in-from-bottom-4 duration-500"><OwnerChat planId={plan.id} client={client} /></div>}
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default OwnerPreviewModal;